import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useHandlers, useData } from './hooks'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'

type Props = {
  name: string
  label: string
  disabled: boolean
  //onChange: (value: ISalesFunnelStage | null) => void
  salesFunnelStages: ISalesFunnelStage[]
  required?: boolean
}

export function SalesFunnelStageSelect(props: Props) {
  const { name, disabled, salesFunnelStages, required, ...rest } = props

  const statusRequired = required === undefined ? true : required

  const { initialOption, isSubmitting, helperText, showError, ...restUseData } =
    useData({ name, salesFunnelStages, required: statusRequired })

  const { handelChange } = useHandlers({ name })

  return (
    <Box>
      <Select<ISalesFunnelStage>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        error={showError}
        required={statusRequired}
        onChange={(value) => {
          handelChange(value)
        }}
        value={initialOption}
        optionMode={'normal'}
        testId="leadAssignmentLeadStatusInput"
        textFieldProps={{
          InputProps: {
            sx: {
              background: 'white',
            },
          },
        }}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  )
}
